import SectionDetails from './SectionDetails';

export default SectionDetails;
